import { render, staticRenderFns } from "./ListFavouriteItems.vue?vue&type=template&id=1a04f92a"
import script from "./ListFavouriteItems.vue?vue&type=script&lang=js"
export * from "./ListFavouriteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a04f92a')) {
      api.createRecord('1a04f92a', component.options)
    } else {
      api.reload('1a04f92a', component.options)
    }
    module.hot.accept("./ListFavouriteItems.vue?vue&type=template&id=1a04f92a", function () {
      api.rerender('1a04f92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ListFavouriteItems.vue"
export default component.exports